import CoreModule from "modules/Core/core-modules/CoreModule";
import { CYCLES } from "./consts";
import feed from "./state/feed";
import cells from "./state/index";
import ViewCycle from "./components/screens/ViewCycle";
import withParams from "modules/Core/higher-order-components/withParams";

export default new CoreModule({
  name: CYCLES,
  initialState: {
    ...feed.getInitialFeedState(),
  },
  cells: {
    createEntity: feed.cells?.createEntity,
    createCycle: cells.createCycle,
    fetchFeed: feed.cells?.fetchFeed,
    addGatewayToActiveCycle: cells.addGatewayToActiveCycle,
    reorderCycleGateway: cells.reorderCycleGateway,
    removeGatewayFromActiveCycle: cells.removeGatewayFromActiveCycle,
    setFilters: feed.cells?.setFilters,
    addGatewayToCycle: cells.addGatewayToCycle,
    upsertActivity: cells.upsertActivity,
    stampActivity: cells.stampActivity,
    setCycleFlow: cells.setCycleFlow,
    reorderCycleActivity: cells.reorderCycleActivity,
    removeActivityFromCycle: cells.removeActivityFromCycle,
    assignActivityToCycle: cells.assignActivityToCycle,
    focusCycle: cells.focusCycle,
    fetchCurrentCycle: cells.fetchCurrentCycle,
    fetchEntity: feed.cells?.fetchEntity,
    completeCycle: cells.completeCycle,
  },
  routes: {
    "/cycles/:id": withParams(ViewCycle)
  },
});
